// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import vuex from 'vuex'
import Egrid from 'egrid'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/iconfont.css'
import '@/assets/styles/main.scss'
import '@/assets/styles/common.css'
import store from './store/store'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import * as filters from './common/filters.js'
import * as API from '../src/api/api';
// import './rem.js'
import 'lib-flexible' // 阿里可伸缩布局方案
Vue.prototype.$API = API.default
Vue.use(ElementUI)
Vue.use(Egrid)
Vue.use(vuex)
Vue.use(Viewer)

Vue.config.productionTip = false;
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js